<template>
  <div class="jd-section f" v-if="applicantJd">
    <div class="jd-section-header">
      <h3>スカウトに添付する求人</h3>
    </div>
    <div class="jd-section-content">
      {{ applicantJd.job_title }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ScoutJobSection',
  // props: {
  //   applicantJd: {
  //     type: Object,
  //     default: () => null
  //   }
  // },
  computed: {
    ...mapGetters({
      applicantJd: 'getApplicantJd',
    }),
  },
  mounted() {
    console.log(this.applicantJd);
  },
};
</script>

<style scoped>
.jd-section {
  padding: 10px;
  background: white;
  border-radius: 10px;
}

.jd-section-content {
  font-size: 15px;
  color: #036ac9;
}
</style>
